export const ACCESS_TOKEN_NAME = "adminToken";
export const REFRESH_TOKEN_NAME = "refreshToken";